import { render, staticRenderFns } from "./JudgementListIframe.vue?vue&type=template&id=37978aa5&"
import script from "./JudgementListIframe.vue?vue&type=script&lang=ts&"
export * from "./JudgementListIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports